import React, { useState, useEffect } from "react"
import getFechas from "../services/getFechas"
import getTabla from "../services/getTabla"
import Tabla from './Tabla'

export default function Partidos({ dia: diaActual }) {
  const [loading, setLoading] = useState(false)
  const [fechasPartidos, updateFechas] = useState([])
  const [tablaJugada, updateTabla] = useState([])
  const [tablaOriginal, updateTablaOriginal] = useState([])
  const [btnCalcular, updateCalcular] = useState(false)

  useEffect(function () {
    setLoading(true)
    getFechas()
      .then(fechas => {
        updateFechas(fechas)
        setLoading(false)
      })

    getTabla()
      .then(tabla => {
        updateTabla(tabla)
        updateTablaOriginal(tabla)
        setLoading(false)
      })
  }, [])

  const handeSubmit = (evt) => {
    evt.preventDefault()

    getTabla()
      .then(tabla => {
        //updateTabla(tabla)
        //updateTablaOriginal(tabla)
    })

    let tablaResult = []
    if (btnCalcular === false) {
      return false
    }
    let partidos = document.getElementsByClassName("partido")
    for (let index = 0; index < partidos.length; index++) {
      // Get input objects
      let Local = partidos[index].childNodes[0].childNodes[1].childNodes[0]
      let Visitante = partidos[index].childNodes[2].childNodes[0].childNodes[0]
      
      // get Goal values from imput
      let golesLocal = parseInt(Local.value)
      let golesVisitante = parseInt(Visitante.value)
      
      // get team name as id for calculations
      let nombreLocal = Local.dataset.equipo.toLowerCase().trim()
      let nombreVisitante = Visitante.dataset.equipo.toLowerCase().trim()

      //if(Local.name.split('|')[4] === '' && Visitante.name.split('|')[4] === '') {//si tiene resultado no actualiza la tabla

        if (parseInt(Local.value) >= 0 && parseInt(Visitante.value) >= 0) {
          let filaLocal = tablaJugada.find(fila => fila.EQUIPO.toLowerCase().trim() ===  nombreLocal)
          let filaVisitante = tablaJugada.find(fila => fila.EQUIPO.toLowerCase().trim() ===  nombreVisitante)
          let origLocal = tablaOriginal.find(elem => elem.EQUIPO.toLowerCase().trim() === nombreLocal)
          let origVisitante = tablaOriginal.find(elem => elem.EQUIPO.toLowerCase().trim() === nombreVisitante)
          
          if (golesLocal > golesVisitante) {
            
              // Local wins
              filaLocal.PUNTOS = parseInt(origLocal.PUNTOS) + 3
              filaVisitante.PUNTOS = parseInt(origVisitante.PUNTOS) + 0

              filaLocal.PJ = parseInt(origLocal.PJ) + 1
              filaVisitante.PJ = parseInt(origVisitante.PJ) + 1

              filaLocal.PG = parseInt(origLocal.PG) + 1
              filaVisitante.PG = parseInt(origVisitante.PG) + 0

              filaLocal.PE = parseInt(origLocal.PE) + 0
              filaVisitante.PE = parseInt(origVisitante.PE) + 0

              filaLocal.PP = parseInt(origLocal.PP) + 0
              filaVisitante.PP = parseInt(origVisitante.PP) + 1

              filaLocal.DF = parseInt(origLocal.DF) + (golesLocal - golesVisitante)
              filaVisitante.DF = parseInt(origVisitante.DF) + (golesVisitante - golesLocal)

          } else if (golesLocal < golesVisitante) {
            
              // visitor wins
              filaLocal.PUNTOS = parseInt(origLocal.PUNTOS) + 0
              filaVisitante.PUNTOS = parseInt(origVisitante.PUNTOS) + 3

              filaLocal.PJ = parseInt(origLocal.PJ) + 1
              filaVisitante.PJ = parseInt(origVisitante.PJ) + 1

              filaLocal.PG = parseInt(origLocal.PG) + 0
              filaVisitante.PG = parseInt(origVisitante.PG) + 1

              filaLocal.PE = parseInt(origLocal.PE) + 0
              filaVisitante.PE = parseInt(origVisitante.PE) + 0

              filaLocal.PP = parseInt(origLocal.PP) + 1
              filaVisitante.PP = parseInt(origVisitante.PP) + 0

              filaLocal.DF = parseInt(origLocal.DF) + (golesLocal - golesVisitante)
              filaVisitante.DF = parseInt(origVisitante.DF) + (golesVisitante - golesLocal)
            
          } else {
            
              filaLocal.PUNTOS = parseInt(origLocal.PUNTOS) + 1
              filaVisitante.PUNTOS = parseInt(origVisitante.PUNTOS) + 1

              filaLocal.PJ = parseInt(origLocal.PJ) + 1
              filaVisitante.PJ = parseInt(origVisitante.PJ) + 1

              filaLocal.PG = parseInt(origLocal.PG) + 0
              filaVisitante.PG = parseInt(origVisitante.PG) + 0

              filaLocal.PE = parseInt(origLocal.PE) + 1
              filaVisitante.PE = parseInt(origVisitante.PE) + 1

              filaLocal.PP = parseInt(origLocal.PP) + 0
              filaVisitante.PP = parseInt(origVisitante.PP) + 0

              filaLocal.DF = parseInt(origLocal.DF) + 0
              filaVisitante.DF = parseInt(origVisitante.DF) + 0
            
          }
          tablaResult.push(filaLocal)
          tablaResult.push(filaVisitante)
        }
    }

    // Change order of table
    tablaResult = tablaResult.sort(function(a,b) {
      let retval = 0;
      if (parseInt(a.PUNTOS) > parseInt(b.PUNTOS))
        retval = -1;
      if (parseInt(a.PUNTOS) < parseInt(b.PUNTOS))
        retval = 1;
      if (retval === 0)
        retval = parseInt(a.DF) < parseInt(b.DF) ? 1 : -1;
      return retval;
    })

    

    updateTabla(tablaResult)
    updateCalcular(false);
  }

  const handleReset = (evt) => {
    evt.preventDefault()
    let partidos = document.getElementsByClassName("partido")
    for (let index = 0; index < partidos.length; index++) {
      let Local = partidos[index].childNodes[0].childNodes[1].childNodes[0]
      let Visitante = partidos[index].childNodes[2].childNodes[0].childNodes[0]
      
      //console.log(Local.name.split('|')[4])

      //if(Local.name.split('|')[4] === '' && Visitante.name.split('|')[4] === '') {
      Local.value = ""
      Visitante.value = ""
      //}
    }

    getFechas()
      .then(fechas => {
        updateFechas(fechas)
      })
    getTabla()
      .then(tabla => {
        updateTabla(tabla)
        updateTablaOriginal(tabla)
      })
    //updateCalcular(false)
  }

  const handeChange = (evt) => {
    let target = evt.target
    let value = target.value
    let name = target.name.split('|')
    let origFechas = fechasPartidos
    let partidoJson = origFechas.find(fp => (fp.PARTIDO === name[0] && fp[name[1]] === name[2]) )
    partidoJson[name[3]] = value
    
    let partidos = document.getElementsByClassName("partido")
    let habilitarBoton = false
    for (let index = 0; index < partidos.length; index++) {
      let Local = partidos[index].childNodes[0].childNodes[1].childNodes[0]
      let Visitante = partidos[index].childNodes[2].childNodes[0].childNodes[0]


      if (parseInt(Local.value) >= 0 && parseInt(Visitante.value) >= 0) {
        habilitarBoton = true
      } else {
        habilitarBoton = false
      }

    }

    updateCalcular(habilitarBoton)
    updateFechas(origFechas)
  }

  if (loading) return <div className="Preloader">Cargando Partidos</div>

  return (
    <React.Fragment>
      <form id="partidosForm" onSubmit={handeSubmit}>
        <dvi className="partidos">
          {
            fechasPartidos.map((fecha) => {
              return fecha.PARTIDO === diaActual && <div className="partido" key={`${fecha.PARTIDO}${fecha.E1}${fecha.E2}`}>
                <div className="equipo-container">
                  <div className="equipo-info">
                    <div className="local-logo">
                      <img src={fecha.LOGO1} align="absmiddle" alt={fecha.E1} title={fecha.E1} />
                    </div>
                    <div className="local-nombre">{fecha.E1}</div>
                  </div>
                  <div className="local-goles input-goles">
                    <input onChange={handeChange} className="goles-local" type="text" pattern="^[0-9]+" min="0" maxLength="2" placeholder="_" data-equipo={fecha.E1} defaultValue={fecha.GE1} name={`${fecha.PARTIDO}|E1|${fecha.E1}|GE1|${fecha.GE1}`} autoComplete="off" />
                  </div>
                </div>
                <div className="vs"><i>VS</i></div>
                <div className="equipo-container">
                  <div className="visitante-goles input-goles">
                    <input onChange={handeChange} className="goles-visitante" type="text" pattern="^[0-9]+" min="0" maxLength="2" placeholder="_" data-equipo={fecha.E2} defaultValue={fecha.GE2} name={`${fecha.PARTIDO}|E2|${fecha.E2}|GE2|${fecha.GE1}`} autoComplete="off" />
                  </div> 
                  <div className="equipo-info">
                    <div className="visitante-logo">
                      <img src={fecha.LOGO2} align="absmiddle" alt={fecha.E2} title={fecha.E2} />
                    </div>
                    <div className="visitante-nombre">{fecha.E2}</div>
                  </div>
                </div>
              </div>
            })
          }
        </dvi>
        <div className="acciones">
          <input type="submit" value="Calcular" disabled={!btnCalcular}/>
          <input type="button" value="Limpiar" onClick={handleReset} />
        </div>
      </form>
      <h3>Tabla de Posiciones</h3>
      <Tabla tabla={tablaJugada} />
    </React.Fragment>
  )
}